/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Duplicate_Disabled_KiotvietInputs */

const vi_order_duplicate_disabled_kiotviet = /** @type {(inputs: Order_Duplicate_Disabled_KiotvietInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn tạo từ hoá đơn KiotViet không sao chép được — hãy tạo đơn mới`)
};

/**

* @param {Order_Duplicate_Disabled_KiotvietInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_duplicate_disabled_kiotviet = /** @type {((inputs?: Order_Duplicate_Disabled_KiotvietInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Duplicate_Disabled_KiotvietInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_duplicate_disabled_kiotviet(inputs)
});